type AnyDict = Record<string, any>;

// Blog key aliases: component uses left key, locale files use right key
const BLOG_KEY_ALIASES: Record<string, string> = {
  // Medical/Healthcare
  aiForMedicalClinics: "medicalClinics",
  
  // Restaurants
  aiForRestaurants: "restaurants",
  
  // Real Estate
  aiForRealEstate: "realEstate",
  
  // Small Business
  aiReceptionistSmallBusiness: "aiReceptionist",
  
  // Cost/ROI
  reduceCustomerSupportCosts: "reduceCosts",
  aiVsHumanAgentsCost: "aiVsHuman",
  
  // Setup/Implementation
  howToSetUpAICallCenter: "callCenterSetup",
  
  // Future/Trends
  futureOfAICustomerService: "futureAI",
  
  // Software Reviews
  bestAIPhoneAgentSoftware: "bestSoftware",
  
  // Comparison
  aiVoiceAgentVsChatbot: "voiceVsChatbot",
  
  // Integration
  integrateAIWhatsApp: "whatsappIntegration",
  
  // Use Cases
  topWaysAIPhoneSupport: "topWays",
};

// Category labels for all languages
const BLOG_CATEGORY_LABELS: Record<string, Record<string, string>> = {
  en: {
    healthcare: "Healthcare",
    restaurants: "Restaurants",
    realEstate: "Real Estate",
    smallBusiness: "Small Business",
    roiSavings: "ROI & Savings",
    costAnalysis: "Cost Analysis",
    implementationGuide: "Implementation Guide",
    integration: "Integration",
    softwareReview: "Software Review",
    industryTrends: "Industry Trends",
    comparison: "Comparison",
    useCases: "Use Cases",
    aiBasics: "AI Basics",
    innovation: "Innovation",
    guides: "Guides",
    future: "Future Trends",
    industry: "Industry",
  },
  fr: {
    healthcare: "Santé",
    restaurants: "Restaurants",
    realEstate: "Immobilier",
    smallBusiness: "Petites entreprises",
    roiSavings: "ROI & économies",
    costAnalysis: "Analyse des coûts",
    implementationGuide: "Guide de mise en œuvre",
    integration: "Intégration",
    softwareReview: "Revue logicielle",
    industryTrends: "Tendances du secteur",
    comparison: "Comparaison",
    useCases: "Cas d'usage",
    aiBasics: "Bases de l'IA",
    innovation: "Innovation",
    guides: "Guides",
    future: "Tendances futures",
    industry: "Industrie",
  },
  de: {
    healthcare: "Gesundheitswesen",
    restaurants: "Restaurants",
    realEstate: "Immobilien",
    smallBusiness: "Kleine Unternehmen",
    roiSavings: "ROI & Einsparungen",
    costAnalysis: "Kostenanalyse",
    implementationGuide: "Implementierungsleitfaden",
    integration: "Integration",
    softwareReview: "Software-Bewertung",
    industryTrends: "Branchentrends",
    comparison: "Vergleich",
    useCases: "Anwendungsfälle",
    aiBasics: "KI-Grundlagen",
    innovation: "Innovation",
    guides: "Anleitungen",
    future: "Zukunftstrends",
    industry: "Industrie",
  },
  es: {
    healthcare: "Salud",
    restaurants: "Restaurantes",
    realEstate: "Bienes raíces",
    smallBusiness: "Pequeñas empresas",
    roiSavings: "ROI y ahorros",
    costAnalysis: "Análisis de costos",
    implementationGuide: "Guía de implementación",
    integration: "Integración",
    softwareReview: "Revisión de software",
    industryTrends: "Tendencias del sector",
    comparison: "Comparación",
    useCases: "Casos de uso",
    aiBasics: "Fundamentos de IA",
    innovation: "Innovación",
    guides: "Guías",
    future: "Tendencias futuras",
    industry: "Industria",
  },
  pt: {
    healthcare: "Saúde",
    restaurants: "Restaurantes",
    realEstate: "Imobiliário",
    smallBusiness: "Pequenas empresas",
    roiSavings: "ROI e economia",
    costAnalysis: "Análise de custos",
    implementationGuide: "Guia de implementação",
    integration: "Integração",
    softwareReview: "Análise de software",
    industryTrends: "Tendências do setor",
    comparison: "Comparação",
    useCases: "Casos de uso",
    aiBasics: "Fundamentos de IA",
    innovation: "Inovação",
    guides: "Guias",
    future: "Tendências futuras",
    industry: "Indústria",
  },
  ar: {
    healthcare: "الرعاية الصحية",
    restaurants: "المطاعم",
    realEstate: "العقارات",
    smallBusiness: "الأعمال الصغيرة",
    roiSavings: "العائد والتوفير",
    costAnalysis: "تحليل التكاليف",
    implementationGuide: "دليل التنفيذ",
    integration: "التكامل",
    softwareReview: "مراجعة البرمجيات",
    industryTrends: "اتجاهات الصناعة",
    comparison: "المقارنة",
    useCases: "حالات الاستخدام",
    aiBasics: "أساسيات الذكاء الاصطناعي",
    innovation: "الابتكار",
    guides: "الأدلة",
    future: "اتجاهات المستقبل",
    industry: "الصناعة",
  },
  ja: {
    healthcare: "医療",
    restaurants: "レストラン",
    realEstate: "不動産",
    smallBusiness: "中小企業",
    roiSavings: "ROI・コスト削減",
    costAnalysis: "コスト分析",
    implementationGuide: "導入ガイド",
    integration: "統合",
    softwareReview: "ソフトウェアレビュー",
    industryTrends: "業界トレンド",
    comparison: "比較",
    useCases: "ユースケース",
    aiBasics: "AI基礎",
    innovation: "イノベーション",
    guides: "ガイド",
    future: "将来のトレンド",
    industry: "業界",
  },
  hi: {
    healthcare: "स्वास्थ्य सेवा",
    restaurants: "रेस्तरां",
    realEstate: "रियल एस्टेट",
    smallBusiness: "छोटे व्यवसाय",
    roiSavings: "ROI और बचत",
    costAnalysis: "लागत विश्लेषण",
    implementationGuide: "कार्यान्वयन गाइड",
    integration: "एकीकरण",
    softwareReview: "सॉफ्टवेयर समीक्षा",
    industryTrends: "उद्योग रुझान",
    comparison: "तुलना",
    useCases: "उपयोग के मामले",
    aiBasics: "AI मूल बातें",
    innovation: "नवाचार",
    guides: "गाइड",
    future: "भविष्य के रुझान",
    industry: "उद्योग",
  },
  zh: {
    healthcare: "医疗",
    restaurants: "餐饮",
    realEstate: "房地产",
    smallBusiness: "小型企业",
    roiSavings: "ROI与节省",
    costAnalysis: "成本分析",
    implementationGuide: "实施指南",
    integration: "集成",
    softwareReview: "软件评测",
    industryTrends: "行业趋势",
    comparison: "对比",
    useCases: "用例",
    aiBasics: "AI基础",
    innovation: "创新",
    guides: "指南",
    future: "未来趋势",
    industry: "行业",
  },
  he: {
    healthcare: "בריאות",
    restaurants: "מסעדות",
    realEstate: "נדל״ן",
    smallBusiness: "עסקים קטנים",
    roiSavings: "ROI וחיסכון",
    costAnalysis: "ניתוח עלויות",
    implementationGuide: "מדריך הטמעה",
    integration: "אינטגרציה",
    softwareReview: "סקירת תוכנה",
    industryTrends: "מגמות בתעשייה",
    comparison: "השוואה",
    useCases: "מקרי שימוש",
    aiBasics: "יסודות AI",
    innovation: "חדשנות",
    guides: "מדריכים",
    future: "מגמות עתידיות",
    industry: "תעשייה",
  },
};

function deepClone<T>(obj: T): T {
  // structuredClone is supported in modern browsers; fallback keeps things safe.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const sc = (globalThis as any).structuredClone as ((v: unknown) => unknown) | undefined;
  if (typeof sc === "function") return sc(obj) as T;
  return JSON.parse(JSON.stringify(obj)) as T;
}

export function withTranslationAliases(input: AnyDict, lng: string): AnyDict {
  const translation = deepClone(input ?? {});

  // Ensure blog and categories objects exist
  translation.blog = translation.blog ?? {};
  translation.blog.categories = translation.blog.categories ?? {};

  // Inject category labels for this language
  const catLabels = BLOG_CATEGORY_LABELS[lng] ?? BLOG_CATEGORY_LABELS.en;
  for (const [key, label] of Object.entries(catLabels)) {
    if (!translation.blog.categories[key]) {
      translation.blog.categories[key] = label;
    }
  }

  // Create aliases: if component uses newKey but locale has oldKey, copy oldKey to newKey
  for (const [newKey, oldKey] of Object.entries(BLOG_KEY_ALIASES)) {
    if (!translation.blog[newKey] && translation.blog[oldKey]) {
      translation.blog[newKey] = translation.blog[oldKey];
    }
  }

  return translation;
}
